export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
export const COUNTRIES = [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'AndorrA', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia', code: 'BO' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: 'Cote D\'Ivoire', code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic Of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: 'Lao People\'S Democratic Republic', code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Netherlands Antilles', code: 'AN' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestinian Territory, Occupied', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Reunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'RWANDA', code: 'RW' },
    { name: 'Saint Helena', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia and Montenegro', code: 'CS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' }
]
export const US_STATES = [
    {
        "name": "Alabama",
        "abbreviation": "AL"
    },
    {
        "name": "Alaska",
        "abbreviation": "AK"
    },
    {
        "name": "American Samoa",
        "abbreviation": "AS"
    },
    {
        "name": "Arizona",
        "abbreviation": "AZ"
    },
    {
        "name": "Arkansas",
        "abbreviation": "AR"
    },
    {
        "name": "California",
        "abbreviation": "CA"
    },
    {
        "name": "Colorado",
        "abbreviation": "CO"
    },
    {
        "name": "Connecticut",
        "abbreviation": "CT"
    },
    {
        "name": "Delaware",
        "abbreviation": "DE"
    },
    {
        "name": "District Of Columbia",
        "abbreviation": "DC"
    },
    {
        "name": "Federated States Of Micronesia",
        "abbreviation": "FM"
    },
    {
        "name": "Florida",
        "abbreviation": "FL"
    },
    {
        "name": "Georgia",
        "abbreviation": "GA"
    },
    {
        "name": "Guam",
        "abbreviation": "GU"
    },
    {
        "name": "Hawaii",
        "abbreviation": "HI"
    },
    {
        "name": "Idaho",
        "abbreviation": "ID"
    },
    {
        "name": "Illinois",
        "abbreviation": "IL"
    },
    {
        "name": "Indiana",
        "abbreviation": "IN"
    },
    {
        "name": "Iowa",
        "abbreviation": "IA"
    },
    {
        "name": "Kansas",
        "abbreviation": "KS"
    },
    {
        "name": "Kentucky",
        "abbreviation": "KY"
    },
    {
        "name": "Louisiana",
        "abbreviation": "LA"
    },
    {
        "name": "Maine",
        "abbreviation": "ME"
    },
    {
        "name": "Marshall Islands",
        "abbreviation": "MH"
    },
    {
        "name": "Maryland",
        "abbreviation": "MD"
    },
    {
        "name": "Massachusetts",
        "abbreviation": "MA"
    },
    {
        "name": "Michigan",
        "abbreviation": "MI"
    },
    {
        "name": "Minnesota",
        "abbreviation": "MN"
    },
    {
        "name": "Mississippi",
        "abbreviation": "MS"
    },
    {
        "name": "Missouri",
        "abbreviation": "MO"
    },
    {
        "name": "Montana",
        "abbreviation": "MT"
    },
    {
        "name": "Nebraska",
        "abbreviation": "NE"
    },
    {
        "name": "Nevada",
        "abbreviation": "NV"
    },
    {
        "name": "New Hampshire",
        "abbreviation": "NH"
    },
    {
        "name": "New Jersey",
        "abbreviation": "NJ"
    },
    {
        "name": "New Mexico",
        "abbreviation": "NM"
    },
    {
        "name": "New York",
        "abbreviation": "NY"
    },
    {
        "name": "North Carolina",
        "abbreviation": "NC"
    },
    {
        "name": "North Dakota",
        "abbreviation": "ND"
    },
    {
        "name": "Northern Mariana Islands",
        "abbreviation": "MP"
    },
    {
        "name": "Ohio",
        "abbreviation": "OH"
    },
    {
        "name": "Oklahoma",
        "abbreviation": "OK"
    },
    {
        "name": "Oregon",
        "abbreviation": "OR"
    },
    {
        "name": "Palau",
        "abbreviation": "PW"
    },
    {
        "name": "Pennsylvania",
        "abbreviation": "PA"
    },
    {
        "name": "Puerto Rico",
        "abbreviation": "PR"
    },
    {
        "name": "Rhode Island",
        "abbreviation": "RI"
    },
    {
        "name": "South Carolina",
        "abbreviation": "SC"
    },
    {
        "name": "South Dakota",
        "abbreviation": "SD"
    },
    {
        "name": "Tennessee",
        "abbreviation": "TN"
    },
    {
        "name": "Texas",
        "abbreviation": "TX"
    },
    {
        "name": "Utah",
        "abbreviation": "UT"
    },
    {
        "name": "Vermont",
        "abbreviation": "VT"
    },
    {
        "name": "Virgin Islands",
        "abbreviation": "VI"
    },
    {
        "name": "Virginia",
        "abbreviation": "VA"
    },
    {
        "name": "Washington",
        "abbreviation": "WA"
    },
    {
        "name": "West Virginia",
        "abbreviation": "WV"
    },
    {
        "name": "Wisconsin",
        "abbreviation": "WI"
    },
    {
        "name": "Wyoming",
        "abbreviation": "WY"
    }
];

export const ORDER_TYPES = {
    SOLE: 'SoleProprietor',
    PARTNERSHIP: 'Partnership',
    CORPORATION: 'Corporation',
    LLC: 'LLC',
    ESTATE: 'Estate',
    TRUST: 'Trust'
}

export const SUB_TYPES = {
    PARTNERSHIP: 'Partnership',
    JOINT: 'Joint Venture',
    CORPORATION: 'Corporation',
    SCORPORATION: 'S Corporation',
    PSCORPORATION: 'Personal Service Corporation',
    REIT: 'REIT',
    RIC: 'RIC',
    SETTLEMENT_FUND: 'Settlement Fund'
};

export const TRUST_SUB_TYPES = {
    ESCROW: 'Escrow',
    BANKRUPTCY_ESTATE: "Bankruptcy Estate",
    CONSERVATORSHIP: "Conservatorship",
    CUSTODIANSHIP: "Custodianship",
    GUARDIANSHIP: "Guardianship",
};

export const BUSINESS_TYPES = [
  { value: "ACCOMMODATIONS", label: "Accommodations" },
  { value: "CONSTRUCTION", label: "Construction" },
  { value: "FINANCE", label: "Finance" },
  { value: "FOOD_SERVICE", label: "Food Service" },
  { value: "HEALTH_CARE", label: "Health Care" },
  { value: "INSURANCE", label: "Insurance" },
  { value: "MANUFACTURING", label: "Manufacturing" },
  { value: "REAL_ESTATE", label: "Real Estate" },
  { value: "RENTAL_AND_LEASING", label: "Rental & Leasing" },
  { value: "RETAIL", label: "Retail" },
  { value: "SOCIAL_ASSISTANCE", label: "Social Assistance" },
  { value: "TRANSPORTATION", label: "Transportation" },
  { value: "WAREHOUSING", label: "Warehousing" },
  { value: "WHOLESALE", label: "Wholesale" },
  { value: "OTHER", label: "Other" },
];

export const SUB_TYPES_MAP = {
  "SoleProprietor": [],
  "Partnership": [ "Partnership", "Joint Venture" ],
  "Corporation": [ "Corporation", "S Corporation", "Personal Service Corporation", "REIT", "RIC", "Settlement Fund" ],
  "LLC": [],
  "Estate": [],
  "Trust": [ "Bankruptcy Estate", "Charitable Lead Annuity", "Charitable Lead Uni", "Charitable Remainder Annuity",
    "Charitable Remainder Uni", "Conservatorship", "Custodianship", "Escrow", "FNMA", "GNMA", "Guardianship",
    "Irrevocable Trust", "Pooled Income Fund", "Qualified Funeral", "Receivership", "Revocable Trust", "Trust (Others)",
    "Settlement Fund" ],
};

export const BUSINESS_SUB_TYPES_MAP = {
  "ACCOMMODATIONS": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "CASINO", label: "Casino hotel" },
      { value: "HOTEL", label: "Hotel" },
      { value: "MOTEL", label: "Motel" },
      { value: "OTHER", label: "Other", detailsText: "Please specify type of accommodations:" },
    ]
  },
  "CONSTRUCTION": {
    question: "Do you focus on a single construction trade (concrete, framing, glass, roofing, siding, electrical, plumbing, HVAC, flooring, etc.)?",
    options: [
      { value: "YES", label: "Yes", detailsText: "Please specify trade:" },
      { value: "NO", label: "No",
        question: "Please specify your primary business activity in construction:",
        options: [
          { value: "CONSTRUCT_RESIDENTIAL", label: "Construct NEW residential properties" },
          { value: "CONSTRUCT_REMODELING", label: "Remodeling existing residential structures" },
          { value: "CONSTRUCT_NON_RESIDENTIAL", label: "Construct non-residential properties", detailsText: "Please specify type of property constructed:" },
          { value: "CONSTRUCT_OTHER", label: "Construct other types of structures (bridges, highways, etc.)", detailsText: "Please specify type of structure constructed:" },
        ],
      },
    ]
  },
  "FINANCE": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "COMMODITIES_BROKER", label: "Commodities broker" },
      { value: "CREDIT_CARD_ISSUING", label: "Credit card issuing" },
      { value: "INVESTMENT_ADVICE", label: "Investment advice" },
      { value: "INVESTMENT_CLUB", label: "Investment club" },
      { value: "INVESTMENT_HOLDING", label: "Investment holding" },
      { value: "MORTGAGE_AGENT", label: "Mortgage broker" },
      { value: "MORTGAGE_COMPANY", label: "Mortgage company" },
      { value: "PORTFOLIO_MANAGEMENT", label: "Portfolio management" },
      { value: "SALES_FINANCING", label: "Sales financing" },
      { value: "SECURITIES_BROKER", label: "Securities broker" },
      { value: "TRUST_ADMIN", label: "Trust administration" },
      { value: "VENTURE_CAPITAL_COMPANY", label: "Venture capital company" },
      { value: "OTHER", label: "Other", detailsText: "Please specify type of financial activity:" },
    ],
  },
  "FOOD_SERVICE": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "BAR", label: "Bar" },
      { value: "BAR_AND_RESTAURANT", label: "Bar and restaurant" },
      { value: "CATERING_SERVICE", label: "Catering service" },
      { value: "COFFEE_SHOP", label: "Coffee shop" },
      { value: "FAST_FOOD_RESTAURANT", label: "Fast food restaurant" },
      { value: "FULL_SERVICE_RESTAURANT", label: "Full service restaurant" },
      { value: "ICE_CREAM_SHOP", label: "Ice cream shop" },
      { value: "MOBILE_FOOD_SERVICE", label: "Mobile food service" },
      { value: "OTHER", label: "Other", detailsText: "Please specify type of food service:" },
    ],
  },
  "HEALTH_CARE": {
    question: "Does your establishment include medical practitioners having the degree of M.D. (Doctor of medicine) or D.O. (Doctor of osteopathy)?",
    options: [
      { value: "YES", label: "Yes",
        question: "Please choose one of the following that best describes your primary business activity:",
        options: [
          { value: "MEDICAL_DOCTOR", label: "Medical doctor" },
          { value: "PSYCHIATRIST", label: "Psychiatrist" },
          { value: "OTHER", label: "Other mental health practitioner", detailsText: "Please specify type:" },
        ]
      },
      { value: "NO", label: "No",
        question: "Please choose one of the following that best describes your primary business activity:",
        options: [
          { value: "CHIROPRACTOR", label: "Chiropractor" },
          { value: "DENTIST", label: "Dentist" },
          { value: "HMO_MC", label: "HMO medical center" },
          { value: "HOSPITAL", label: "Hospital" },
          { value: "DIALYSIS_CENTER", label: "Kidney dialysis center" },
          { value: "OPTOMETRIST", label: "Optometrist" },
          { value: "CARE_CENTER", label: "Outpatient care center" },
          { value: "PODIATRIST", label: "Podiatrist" },
          { value: "PSYCHOLOGIST", label: "Psychologist" },
          { value: "OTHER_MENTAL", label: "Other mental health practitioner", detailsText: "Please specify:" },
          { value: "OTHER", label: "Other", detailsText: "Please specify:" },
        ]
      },
    ]
  },
  "INSURANCE": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "INSURANCE_CARRIER", label: "Insurance carrier" },
      { value: "INSURANCE_AGENT", label: "Insurance agent/broker" },
      { value: "OTHER", label: "Other", detailsText: "Please specify type of activity:" },
    ],
  },
  "MANUFACTURING": {
    detailsText: "Please specify the type of goods that you manufacture and the primary materials used (such as “wood furniture”):",
  },
  "REAL_ESTATE": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "RENT_PROPERTY", label: "Rent/lease own property",
        question: "Please choose one of the following:",
        options: [
          { value: "RENT_RESIDENTIAL", label: "Rent residential real estate" },
          { value: "RENT_OTHER", label: "Rent commercial, industrial, or other real estate" },
          { value: "OTHER", label: "Other", detailsText: "Please specify:" },
        ]
      },
      { value: "CAPITAL_BUILD", label: "Build property",
        question: "Do you focus on a single construction trade (concrete, framing, glass, roofing, siding, electrical, plumbing, HVAC, flooring, etc.)?",
        options: [
          { value: "YES", label: "Yes", detailsText: "Please specify trade:" },
          { value: "NO", label: "No",
            question: "Please specify your primary business activity in construction:",
            options: [
              { value: "CONSTRUCT_RESIDENTIAL", label: "Construct NEW residential properties" },
              { value: "CONSTRUCT_REMODELING", label: "Remodeling existing residential structures" },
              { value: "CONSTRUCT_NON_RESIDENTIAL", label: "Construct non-residential properties", detailsText: "Please specify type of property constructed:" },
              { value: "CONSTRUCT_OTHER", label: "Construct other types of structures (bridges, highways, etc.)", detailsText: "Please specify type of structure constructed:" },
            ],
          },
        ]
      },
      { value: "SELL_PROPERTY", label: "Sell property for others" },
      { value: "MANAGE_PROPERTY", label: "Manage estate for others" },
      { value: "OTHER", label: "Other", detailsText: "Please specify type of activity:" },
    ]
  },
  "RENTAL_AND_LEASING": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "RENT_ESTATE", label: "Rent, lease, or sell estate",
        question: "Please choose one of the following:",
        options: [
          { value: "REAL_ESTATE_AGENT", label: "I am a real estate agent" },
          { value: "RENT_OWN_RESIDENTIAL", label: "I rent residential real estate that I own" },
          { value: "RENT_OWN_NON_RESIDENTIAL", label: "I rent commercial, industrial, or other real estate that I own" },
        ]
      },
      { value: "RENT_GOODS", label: "Rent or lease goods", detailsText: "Please specify the type of goods:" },
      { value: "MANAGE_ESTATE", label: "Manage estate for others" },
    ]
  },
  "RETAIL": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "SELLING_GOODS", label: "Selling goods (Internet)" },
      { value: "STOREFRONT_SALES", label: "Sales from a storefront", detailsText: "Please specify type of store:" },
      { value: "DIRECT_SALES", label: "Direct sales", detailsText: "Please specify type of selling method (catalogue, mail order, door to door):" },
      { value: "AUCTION_HOUSE", label: "Auction house" },
      { value: "OTHER", label: "Other", detailsText: "Please specify:" },
    ],
  },
  "SOCIAL_ASSISTANCE": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "NURSING_HOME", label: "Nursing home" },
      { value: "SHELTER", label: "Shelter" },
      { value: "YOUTH_SERVICES", label: "Youth services" },
      { value: "OTHER", label: "Other", detailsText: "Please specify type of social assistance:" },
    ]
  },
  "TRANSPORTATION": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "CARGO", label: "Cargo",
        question: "Please choose the primary mode used to transport cargo:",
        options: [
          { value: "AIR", label: "Air" },
          { value: "RAIL", label: "Rail" },
          { value: "TRUCKING", label: "Trucking" },
          { value: "WATER", label: "Water" },
          { value: "OTHER", label: "Other", detailsText: "Please specify:" },
        ]
      },
      { value: "PASSENGERS", label: "Passengers",
        question: "Please choose the primary mode used to transport passengers:",
        options: [
          { value: "LIMOUSINE_SERVICE", label: "Limousine service" },
          { value: "SHUTTLE_BUS", label: "Shuttle bus" },
          { value: "TAXI_SERVICE", label: "Taxi service" },
          { value: "OTHER", label: "Other", detailsText: "Please specify:" },
        ]
      },
      { value: "PROVIDE_SUPPORT", label: "Provide support activity", detailsText: "Please specify the support activity:" },
    ]
  },
  "WAREHOUSING": {},
  "WHOLESALE": {
    question: "Do you own or take title to the goods that you sell?",
    options: [
      { value: "YES", label: "Yes", detailsText: "Please specify type of goods sold:" },
      { value: "NO", label: "No",
        question: "Do you receive a commission or fee from selling these goods?",
        options: [
          { value: "YES", label: "Yes" },
          { value: "NO", label: "No", detailsText: "Please specify type of goods sold:" }
        ]
      },
    ]
  },
  "OTHER": {
    question: "Please choose one of the following that best describes your primary business activity:",
    options: [
      { value: "CONSULTING", label: "Consulting",
        question: "Do you provide operating advice and assistance to businesses and other organizations?",
        options: [
          { value: "YES", label: "Yes", detailsText: "Please specify type of consulting (for example, management, marketing, etc.):" },
          { value: "NO", label: "No", detailsText: "Please specify your primary business activity:" }
        ]
      },
      { value: "MANUFACTURING", label: "Manufacturing",
        detailsText: "Please specify the type of goods that you manufacture and the primary materials used (such as “wood furniture”):"
      },
      { value: "ORGANIZATION", label: "Organization (religious, social, etc.)",
        question: "What is the primary activity of your organization?",
        options: [
          { value: "ATHLETIC", label: "Athletic", detailsText: "Please specify:" },
          { value: "CONSERVATION", label: "Conservation", detailsText: "Please specify:" },
          { value: "ENVIRONMENTAL", label: "Environmental", detailsText: "Please specify:" },
          { value: "FUNDRAISING", label: "Fundraising", detailsText: "Please specify:" },
          { value: "HOMEOWNERS_ASSOCIATION", label: "Homeowners association" },
          { value: "RELIGIOUS", label: "Religious", detailsText: "Please specify:" },
          { value: "SOCIAL_CIVIC", label: "Social or civic", detailsText: "Please specify:" },
          { value: "OTHER", label: "Other", detailsText: "Please specify:" },
        ]
      },
      { value: "RENTAL", label: "Rental",
        question: "Please choose one of the following that best describes your primary business activity:",
        options: [
          { value: "RENT_LEASE_REAL_ESTATE", label: "I rent, lease, or sell real estate",
            question: "Please choose one of the following:",
            options: [
              { value: "REAL_ESTATE_AGENT", label: "I am a real estate agent" },
              { value: "RENT_OWN_RESIDENTIAL", label: "I rent residential real estate that I own" },
              { value: "RENT_OWN_NON_RESIDENTIAL", label: "I rent commercial, industrial, or other real estate that I own" },
            ]
          },
          { value: "RENT_LEASE_GOODS", label: "I rent or lease goods", detailsText: "Please specify the type of goods:" },
        ]
      },
      { value: "REPAIR", label: "Repair",
        detailsText: "What are the primary goods you repair?"
      },
      { value: "OTHER_SELL", label: "Sell goods",
        question: "Please choose one of the following that best describes your primary business activity:",
        options: [
          { value: "RETAIL", label: "Retail",
            question: "Please choose one of the following:",
            options: [
              { value: "SELLING_GOODS", label: "Selling goods (Internet)" },
              { value: "STOREFRONT_SALES", label: "Sales from a storefront", detailsText: "Please specify type of store:" },
              { value: "DIRECT_SALES", label: "Direct sales", detailsText: "Please specify type of selling method (catalogue, mail order, door to door):" },
              { value: "AUCTION_HOUSE", label: "Auction house" },
              { value: "OTHER", label: "Other", detailsText: "Please specify:" },
            ],
          },
          { value: "WHOLESALE", label: "Wholesale",
            question: "Do you own or take title to the goods that you sell?",
            options: [
              { value: "YES", label: "Yes", detailsText: "Please specify type of goods sold:" },
              { value: "NO", label: "No",
                question: "Do you receive a commission or fee from selling these goods?",
                options: [
                  { value: "YES", label: "Yes" },
                  { value: "NO", label: "No", detailsText: "Please specify type of goods sold:" }
                ]
              },
            ],
          },
        ]
      },
      { value: "OTHER_SERVICE", label: "Service",
        detailsText: "What is the primary service you provide?"
      },
      { value: "OTHER", label: "Other", detailsText: "Please specify your primary business activity:" },
    ]
  }
};

export const PENALTY_TYPES = [
  { name: "FTFP", description: "Failure to file penalty" },
  { name: "FTPP", description: "Failure to pay penalty" },
  { name: "FTDP", description: "Failure to deposit penalty" }
];



// WEBPACK FOOTER //
// ./src/scripts/constants.js